var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("組織資料中心")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("模組管理")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s("\u3010".concat(_vm.organizationName, "\u3011\u6A21\u7D44\u7BA1\u7406")) + " ")]), _c('div', {
    staticClass: "\n          col-12 col-xl-6\n          d-flex\n          flex-column flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_vm.checkPermission([_vm.consts.MODULE_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleCreate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增模組 ")]) : _vm._e(), _c('b-form-select', {
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.isFetchMerchants
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  }), _c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋模組名稱"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.modules,
      "fields": _vm.fields,
      "busy": _vm.isLoading
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.config && data.item.config.name) + " "), data.item.config && data.item.config.description ? _c('BIconQuestionCircle', {
          staticClass: "d-inline-block",
          attrs: {
            "id": "popover-tips-".concat(data.item.id)
          }
        }) : _vm._e(), _c('b-popover', {
          attrs: {
            "target": "popover-tips-".concat(data.item.id),
            "triggers": "hover focus click"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v(" " + _vm._s(data.item.config && data.item.config.description) + " ")])])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [data.item.status == 'inactivated' && _vm.checkPermission([_vm.consts.MODULE_LIST_VIEW]) ? _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.handleActivate(data.item.module_code);
            }
          }
        }, [_vm._v(" 開通 ")]) : _vm._e(), data.item.status != 'inactivated' && _vm.checkPermission([_vm.consts.MODULE_MODIFY]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-info",
            "to": {
              name: 'ModuleConfig',
              params: {
                orgId: _vm.orgId,
                moduleId: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-settings"
        }), _vm._v(" 設定 ")]) : _vm._e(), data.item.status != 'inactivated' && _vm.checkPermission([_vm.consts.MODULE_LIST_VIEW]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'ModuleShow',
              params: {
                orgId: _vm.orgId,
                moduleId: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]) : _vm._e(), data.item.status != 'inactivated' && _vm.checkPermission([_vm.consts.MODULE_MODIFY]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'ModuleEdit',
              params: {
                orgId: _vm.orgId,
                moduleId: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), data.item.status != 'inactivated' && _vm.checkPermission([_vm.consts.MODULE_DELETE]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-danger",
            "disabled": data.item.is_enabled === 1
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(data.item.id, data.item.module_code);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.total,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }